import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const FinalizeRecordingPanel = ({
  pendingCount,
  totalSegments,
  loading,
  error,
  onUploadAndComplete
}) => (
  <div className="finalize-recording-panel">
    <div className="finalize-recording-panel-text">
      <strong>Recording stopped</strong>
      <p>
        {pendingCount > 0
          ? `${pendingCount} segment${pendingCount === 1 ? '' : 's'} still need uploading before processing can start.`
          : 'All segments are uploaded. Complete the recording to start processing.'}
        {typeof totalSegments === 'number' ? ` (${totalSegments} total).` : ''}
      </p>
      {error && <p className="finalize-recording-error">{error}</p>}
    </div>
    <button
      type="button"
      className="header-button header-button-primary"
      onClick={onUploadAndComplete}
      disabled={loading}
    >
      {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Upload and complete'}
    </button>
  </div>
);

export default FinalizeRecordingPanel;
